import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleModelService } from '../services/vehicle-model.service';
import Swal from 'sweetalert2';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { CountryCmbDto } from 'src/app/shared/dto/country.dto';
import { StateDto, CityDto } from 'src/app/shared/dto/city.dto';
import { CreateVehicleDTO } from '../vehicle';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrl: './add-vehicle.component.css',
})
export class AddVehicleComponent implements OnInit {
  @Output() vehicleCreated = new EventEmitter<any>();
  @ViewChild('modal21') modal21: any;

  vehicleForm: FormGroup = new FormGroup({});
  listVehicleTypesAll: any[] = [];
  countries: CountryCmbDto[] = [];
  states: StateDto[] = [];
  cities: CityDto[] = [];
  vehicleBrands: any[] = [];

  constructor(
    private fb: FormBuilder,
    private vehicleModelService: VehicleModelService,
    private readonly commonService: CommonService,
    private analitycs: AnalitycsService,
  ) {
    // do nothing
  }
  ngOnInit(): void {
    this.analitycs.logEvent('formulario_agregar_vehiculo', {
      pantalla: 'add-vehicle',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.vehicleForm = this.fb.group({
      typevehicle: ['', Validators.required],
      brand: ['', Validators.required],
      modelo: ['', Validators.required],
      km: ['', [Validators.required]],
      plate: ['', Validators.required],
      color: ['', Validators.required],
      year: ['', Validators.required],
      city: ['', Validators.required],
      country: ['CO', Validators.required],
      state: ['', Validators.required],
    });

    // this.vehicleModelService.getVehicleModels();
    this.getlistVehicleTypesAll();
    this.getAvailableCountriesToCmb();
    this.getAvailableVehicleBrands();
  }

  // Permite abrir la modal desde un componente padre
  open(): void {
    if (this.modal21 && typeof this.modal21.open === 'function') {
      this.modal21.open();
    }
  }

  async getAvailableCountriesToCmb() {
    this.countries = await this.commonService.getAvailableCountriesToCmb();
    this.onPaisChange();
  }

  async onPaisChange() {
    this.states = await this.commonService.getAvailableStatesByCountryCode(this.vehicleForm.get('country')?.value);
    this.vehicleForm.patchValue({ state: '', city: '' });
  }

  async onStateChange() {
    this.cities = await this.commonService.getAvailableCityByStateCountryCode(this.vehicleForm.get('country')?.value, this.vehicleForm.get('state')?.value);
    this.vehicleForm.patchValue({ city: '' });
  }

  async onSubmit() {
    this.analitycs.logEvent('el_usuario_creo_un_vehiculo', {
      pantalla: 'add-vehicle',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    if (this.vehicleForm.valid) {
      const formValue = this.vehicleForm.value;

      // Obtener los objetos completos de país, estado y ciudad
      const selectedCountry = this.countries.find((country) => country.cca2 === formValue.country);
      const selectedState = this.states.find((state) => state.state_code === formValue.state);
      const selectedCity = this.cities.find((city) => city.city_code === formValue.city);

      const vehicleData: CreateVehicleDTO = {
        plate: formValue.plate,
        year: formValue.year,
        typevehicle: formValue.typevehicle,
        brand: formValue.brand,
        vehicle_model: formValue.modelo,
        km: formValue.km,
        city: {
          code: selectedCity?.city_code || '',
          name: selectedCity?.city_name || '',
        },
        state: {
          code: selectedState?.state_code || '',
          name: selectedState?.state_name || '',
        },
        country: {
          code: selectedCountry?.cca2 || '',
          name: selectedCountry?.name.common || '',
        },
        color: formValue.color,
        status: true,
        createdBy: 'PLATFORM',
      };

      await this.vehicleModelService.createVehicleModel(vehicleData);
      Swal.fire({
        toast: true,
        icon: 'success',
        title: '¡Éxito!',
        text: 'Vehículo registrado correctamente',
        confirmButtonText: 'Aceptar',
      });

      this.vehicleCreated.emit(true);
      // Resetear formulario
      this.vehicleForm.reset();

      // Cerrar la modal
      this.modal21.close();
    } else {
      //   console.error('Formulario inválido, ¡corrige los errores! 😅');
    }
  }

  selectColor(color: string): void {
    this.analitycs.logEvent('el_usuario_selecciono_color_del_vehiculo', {
      pantalla: 'add-vehicle',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.vehicleForm.get('color')?.setValue(color);
  }

  async getlistVehicleTypesAll() {
    const result = (await this.commonService.getlistVehicleTypesAll()).map((option: any) => {
      return {
        _id: option._id,
        name: option.name.es,
      };
    });

    this.listVehicleTypesAll = result;
  }

  async getAvailableVehicleBrands() {
    const result = await this.commonService.getAvailableVehicleBrands();
    this.vehicleBrands = Array.isArray(result) ? result : (result as any)?.MARCAS || [];
  }
}
